<form [formGroup]="providentFundForm" (ngSubmit)="saveProvidentFund(inProgress)">
    <div class="modal-header">
        <h5 class="modal-title d-flex align-items-center">
            <i class="ri-exchange-dollar-fill me-1 font-20 text-primary"></i>{{providentFundForm.value.id?'Update':'Add'}} Provident Fund
        </h5>
        <button type="button" class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close"
            (click)="activeModal.close('Close')"></button>
    </div>
    <div class="modal-body">
        <div class="row g-3">
            <div class="col-md-6">
                <label for="name" class="form-label">Provident Fund<b class="text-secondary">*</b></label>
                <div class="input-group">
                    <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-user'></i></span>
                    <input type="text" class="form-control ps-1" id="name" placeholder="Enter provident Fund"
                        [ngClass]="{'is-invalid': submitted && f.name.errors}" formControlName="name" ngbAutofocus
                        autocomplete="off" />
                    <div class="invalid-feedback" *ngIf="submitted && f.name.errors">
                        <span *ngIf="f.name.errors.required">Please enter a valid provident Fund.</span>
                        <span *ngIf="f.name.errors.pattern">Only letters are allowed.</span>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <label for="type" class="form-label">Type <b class="text-secondary">*</b></label>
                <div class="input-group">
                    <span class="input-group-text bg-transparent border-end-0"><i class='bx bxs-grid-alt'></i></span>
                    <ng-select class="form-control rcx-ng-select" formControlName="type" placeholder="Select type"
                        [ngClass]="{'is-invalid': submitted && f.type.errors}" [clearable]="false"
                        (change)="onTypeChange($event)">
                        <ng-option *ngFor="let type of types" [value]="type">{{type}}</ng-option>
                    </ng-select>
                    <div class="invalid-feedback" *ngIf="submitted && f.type.errors">
                        <span *ngIf="f.type.errors.required">Please select a type.</span>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <label for="value" class="form-label">Value<b class="text-secondary">*</b></label>
                <div class="input-group">
                    <span class="input-group-text bg-transparent border-end-0">
                        <i class='bx' [ngClass]="getIconClass('value')"></i>
                    </span>
                    <input type="number" class="form-control ps-1" id="value" placeholder="Enter value"
                        [ngClass]="{'is-invalid': submitted && f.value.errors}" formControlName="value"
                        autocomplete="off" (input)="updateValidators()" />
                    <div class="invalid-feedback" *ngIf="submitted && f.value.errors">
                        <span *ngIf="f.value.errors.required">Please enter a valid value.</span>
                        <span *ngIf="f.value.errors.min">Value must be greater than 0.</span>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <label for="employeeRatio" class="form-label">Employee Ratio<b class="text-secondary">*</b></label>
                <div class="input-group">
                    <span class="input-group-text bg-transparent border-end-0">
                        <i class='bx' [ngClass]="getIconClass('ratio')"></i>
                    </span>
                    <input type="number" class="form-control ps-1" id="employeeRatio" placeholder="Enter employee Ratio"
                        [ngClass]="{'is-invalid': submitted && f.employeeRatio.errors}" formControlName="employeeRatio"
                        autocomplete="off" (input)="calculateEmployerRatio()" (keypress)="restrictInput($event)" />
                    <div class="invalid-feedback" *ngIf="submitted && f.employeeRatio.errors">
                        <span *ngIf="f.employeeRatio.errors.required">Please enter a valid employee Ratio.</span>
                        <span *ngIf="f.employeeRatio.errors.min || f.employeeRatio.errors.max">
                            {{providentFundForm.value.type === 'FIXED' ? 'Ratio must be between 0 and value (' + f.value.value + ').' : 'Ratio must be between 0 and 99.'}}
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <label for="employeerRatio" class="form-label">Employer Ratio<b class="text-secondary">*</b></label>
                <div class="input-group">
                    <span class="input-group-text bg-transparent border-end-0">
                        <i class='bx' [ngClass]="getIconClass('ratio')"></i>
                    </span>
                    <input type="number" class="form-control ps-1" id="employeerRatio" placeholder="Auto-calculated"
                        [ngClass]="{'is-invalid': submitted && f.employeerRatio.errors}" formControlName="employeerRatio"
                        autocomplete="off" readonly />
                    <div class="invalid-feedback" *ngIf="submitted && f.employeerRatio.errors">
                        <span *ngIf="f.employeerRatio.errors.required">Please ensure employer ratio is valid.</span>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <label for="label" class="form-label">Description</label>
                <div class="input-group">
                    <span class="input-group-text bg-transparent border-end-0"><i class='bx bxs-comment'></i></span>
                    <input type="text" class="form-control ps-1" id="label" placeholder="Enter description"
                        [ngClass]="{'is-invalid': submitted && f.label.errors}" formControlName="label"
                        autocomplete="off" />
                    <div class="invalid-feedback" *ngIf="submitted && f.label.errors">
                        <span *ngIf="f.label.errors.pattern">Only letters are allowed.</span>
                    </div>
                </div>
            </div>
            <div class="col-md-auto">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="disabled" formControlName="disabled">
                    <label class="form-check-label" for="disabled">Disabled</label>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-light" (click)="activeModal.close('Close')"><i class="bx bx-x"></i>Close</button>
        <button type="submit" class="btn btn-secondary" #inProgress [ngClass]="{'no-event': inProgress?.value=='true'}">
            <ng-container *ngIf="inProgress?.value=='true'">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                {{providentFundForm.value.id?'Updating...':'Saving...'}}
            </ng-container>
            <ng-container *ngIf="inProgress?.value!='true'">
                <i class="bx bx-save"></i>{{providentFundForm.value.id?'Save Changes':'Save'}}
            </ng-container>
        </button>
    </div>
</form>